import {getPricingOptionLabel} from '@wix/wix-events-commons-statics'
import {TFunction, useTranslation} from '@wix/yoshi-flow-editor'
import {Type} from '@wix/ambassador-seating-v1-seating-plan/types'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import React from 'react'
import ChevronDown from 'wix-ui-icons-common/ChevronDown'
import ChevronUp from 'wix-ui-icons-common/ChevronUp'
import s from '../ticket-details.scss'
import {SelectedTicketInfo} from '../../../../../types'
import {useCurrencyFormatter} from '../../../../../../../../commons/hooks/currency'
import {TicketDetailsHeaderProps} from './interfaces'

export const TicketDetailsHeader = ({
  ticketIndex,
  ticket,
  editable,
  expanded,
  onExpand,
  details,
}: TicketDetailsHeaderProps) => {
  const {t} = useTranslation()
  const {getFormattedMoney} = useCurrencyFormatter()
  const subtitle = getSubtitle(ticket, t, getFormattedMoney)

  return (
    <div className={s.header} onClick={editable ? onExpand : null}>
      <div className={s.title} aria-expanded={expanded} role="button" data-hook={DH.TICKET_DETAILS_HEADER_TITLE}>
        <div>
          {t('mobile.checkout.ticket.title', {
            index: ticketIndex + 1,
            name: ticket.name,
            interpolation: {escapeValue: false},
          })}
        </div>
        {editable &&
          (expanded ? (
            <ChevronUp className={s.arrow} aria-hidden={true} />
          ) : (
            <ChevronDown className={s.arrow} aria-hidden={true} />
          ))}
      </div>
      {subtitle && <div className={s.ticketSubtitle}>{subtitle}</div>}
      {details && !expanded && (
        <div className={s.details}>
          <div>
            {details.firstName} {details.lastName}
          </div>
          <div>{details.email}</div>
        </div>
      )}
    </div>
  )
}

const getSubtitle = (ticket: SelectedTicketInfo, t: TFunction, getFormattedMoney) => {
  const {place, pricingOptionId} = ticket
  const parts = []
  if (pricingOptionId) {
    const pricingOptionLabel = getPricingOptionLabel(ticket, pricingOptionId, getFormattedMoney)
    parts.push(pricingOptionLabel)
  }
  if (place) {
    const area = place.elementType === Type.AREA
    const table = [Type.TABLE, Type.ROUND_TABLE].includes(place.elementType)

    const sector = place.sector ? `${t('seatings_sector')}: ${place.sector}` : ''
    const elementType = area
      ? `${t('seatings_area')}: ${place.elementLabel}`
      : table
      ? `${t('seatings_table')}: ${place.elementLabel}`
      : `${t('seatings_row')}: ${place.elementLabel}`
    const seat = !area ? `${t('seatings_seat')}: ${place.label}` : ''
    parts.push([sector, elementType, seat].filter(val => val).join(', '))
  }
  return parts.join(', ')
}
